const doc = [({"da":({"js":({"admin":({"agenda_item_element_speakers":({"table":({"speakers":"Talere"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;